import { Typography } from '@prenuvo/halo-web';

const Contacts = () => {
  return (
    <div className="mb-4 mt-2 grid grid-cols-[36px,_1fr] gap-x-1 gap-y-3">
      <Typography variant="paragraph-xs" className="text-xs text-geyser-500">
        Tel:
      </Typography>
      <Typography
        variant="paragraph-xs"
        className="text-xs text-geyser-500 transition ease-in-out hover:text-green-100"
      >
        <a href="tel:+1 833 773 6886">+1 833 773 6886 / +1 833 PRE NUVO</a>
      </Typography>
      <Typography variant="paragraph-xs" className="text-xs text-geyser-500">
        Fax:
      </Typography>
      <Typography
        variant="paragraph-xs"
        className="text-xs text-geyser-500 transition ease-in-out hover:text-green-100"
      >
        <a href="fax:+1 604 245 0236">+1 604 245 0236</a>
      </Typography>
      <Typography variant="paragraph-xs" className="text-xs text-geyser-500">
        Email:
      </Typography>
      <Typography
        variant="paragraph-xs"
        className="text-xs text-geyser-500 transition ease-in-out hover:text-green-100"
      >
        <a href="mailto:hello@prenuvo.com">hello@prenuvo.com</a>
      </Typography>
      <Typography variant="paragraph-xs" className="text-xs text-geyser-500">
        Press:
      </Typography>
      <Typography
        variant="paragraph-xs"
        className="text-xs text-geyser-500 transition ease-in-out hover:text-green-100"
      >
        <a href="mailto:media@prenuvo.com">media@prenuvo.com</a>
      </Typography>
    </div>
  );
};
export default Contacts;
